<template>
  <div class="relative flex h-32 w-64">
    <div
      class="bg-surface-default-low border-static-default-mid rounded-full absolute h-32 w-32 border-1 p-4"
    >
      <RevIllustration
        :alt="i18n(translations.vodafone)"
        :height="24"
        src="/img/product/carriers/vodafone.png"
        :width="24"
      />
    </div>
    <div
      class="bg-surface-default-low border-static-default-mid rounded-full absolute left-16 h-32 w-32 border-1 p-4"
    >
      <RevIllustration
        :alt="i18n(translations.o2)"
        :height="24"
        src="/img/product/carriers/o2.png"
        :width="24"
      />
    </div>
    <div
      class="bg-surface-default-low border-static-default-mid rounded-full absolute left-32 h-32 w-32 border-1 p-4"
    >
      <RevIllustration
        :alt="i18n(translations.ee)"
        :height="24"
        src="/img/product/carriers/ee.png"
        :width="24"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './GBTelcoCalculatorAdvertisementIcons.translations'

const i18n = useI18n()
</script>
